<!--
  Generated template for the ResultEditTrophyPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
		</ion-buttons>
		<ion-title>{{ 'CONFIGURATOR_TITLE' | translate}}</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="save()">
				<!-- <ion-icon item-end name="checkmark"></ion-icon> -->
				{{'GLOBAL_SAVE' | translate}}
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

	<!-- <trophy #trophy [result]="result" offset="210"></trophy> -->

	<ion-card class="config-card">
		<ion-card-header>
			{{ 'CONFIGURATOR_TYPE' | translate }}
		</ion-card-header>
		<ion-card-content class="config-card-content">
			<div class="config-card-scroll-wrapper">
			<ion-row class="config-card-scroll-row">
				<ion-col 
				class="config-card-scroll-fragment" 
				*ngFor="let type of types" 
				(click)="selectType(type)" size="4">
				<div class="config-thumb-trophy" [class.selected]="type.name === selectedType.name">
					<img 
					src="assets/trophy/thumbs/trophies/{{ type.pokal }}" 
					alt="" 
					class="pokal-img"/>
					<p>{{ type.lang | translate }}</p>
				</div>
				</ion-col>
			</ion-row>
			</div>
		</ion-card-content>
	</ion-card>

	<!-- <ion-card no-margin margin-bottom class="config-card">
		<ion-card-header>
			{{ 'CONFIGURATOR_TYPE' | translate}}
		</ion-card-header>
		<ion-card-content no-padding>
			<ion-scroll scrollX="true" class="config-card-scroll" style="height: 174px;">
				<ion-row flex-nowrap>
					<ion-col class="config-card-scroll-fragment" *ngFor="let type of types" (click)="selectType(type)">
						<div class="config-thumb-trophy {{type.name===selectedType.name?'selected':''}}">
							<img src="assets/trophy/thumbs/trophies/{{ type.pokal}}" alt="" class="pokal-img"/>
							<p>{{ type.lang | translate}}</p>
						</div>
					</ion-col>
				</ion-row>
			</ion-scroll>
		</ion-card-content>
	</ion-card> -->

	<ion-card class="config-card" [hidden]="hideOthers">
		<ion-card-header>
			{{ 'CONFIGURATOR_COLOR' | translate}}
		</ion-card-header>
		<ion-card-content no-padding>
			<!-- <ion-scroll scrollX="true" class="config-card-scroll" style="height: 111px;"> -->
			<div class="config-card-scroll-wrapper">
				<ion-row class="config-card-scroll-row">
				<!-- <ion-row flex-nowrap> -->
					<ion-col size="4" *ngFor="let color of colors" (click)="selectColor(color)">
						<div class="config-thumb-prop color {{color.id===selectedColor.id?'selected':''}}">
							<span class="{{color.name}}">{{ color.lang | translate}}</span>
						</div>
					</ion-col>
				</ion-row>
			</div>
			<!-- </ion-scroll> -->
		</ion-card-content>
	</ion-card>

	<ion-card class="config-card" [hidden]="hideOthers">
		<ion-card-header>
			{{ 'CONFIGURATOR_MATERIAL' | translate}}
		</ion-card-header>
		<ion-card-content no-padding>
			<!-- <ion-scroll scrollX="true" class="config-card-scroll" style="height: 109px;"> -->
				<!-- <ion-row flex-nowrap> -->
				<div class="config-card-scroll-wrapper">
				<ion-row class="config-card-scroll-row">

					<ion-col size="4" class="config-card-scroll-fragment" *ngFor="let material of materials"
						(click)="selectMaterial(material)">
						<div class="config-thumb-prop material {{material.id===selectedMaterial.id?'selected':''}}">
							<img src="assets/trophy/thumbs/textures/{{material.img}}" alt="" />
							<p>{{ material.lang | translate}}</p>
						</div>
					</ion-col>
				</ion-row>
				</div>
			<!-- </ion-scroll> -->
		</ion-card-content>
	</ion-card>

	<ion-card class="config-card">
		<ion-card-header>
			{{ 'CONFIGURATOR_DISPLAY' | translate}}
		</ion-card-header>
		<ion-card-content>
			<ion-list class="no-lines">
				<ion-item>
					<ion-label>{{ 'CONFIGURATOR_DISPLAY_DISTANCE' | translate}}</ion-label>
					<ion-checkbox [(ngModel)]="result.hasStrecke" (ionChange)="updateTrophy(0)"></ion-checkbox>
				</ion-item>
				<ion-item>
					<ion-label>{{ 'CONFIGURATOR_DISPLAY_TIME' | translate}}</ion-label>
					<ion-checkbox [(ngModel)]="result.hasZeit" (ionChange)="updateTrophy(1)"></ion-checkbox>
				</ion-item>
				<ion-item>
					<ion-label>{{ 'CONFIGURATOR_DISPLAY_DATE' | translate}}</ion-label>
					<ion-checkbox [(ngModel)]="result.hasDatum" (ionChange)="updateTrophy(2)"></ion-checkbox>
				</ion-item>
				<ion-item>
					<ion-label>{{ 'CONFIGURATOR_DISPLAY_PLACE' | translate}}</ion-label>
					<ion-checkbox [(ngModel)]="result.hasPlatz" (ionChange)="updateTrophy(3)"></ion-checkbox>
				</ion-item>
			</ion-list>
		</ion-card-content>
	</ion-card>

</ion-content>